import React from 'react';
import './WASHHero.css';

const WASHHero = () => {
  return (
    <section className="wash-hero">
      <div className="wash-hero-overlay">
        <div className="wash-hero-content">
          <h1>Water, Sanitation & Hygiene (WASH)</h1>
          <p>Ensuring access to clean water and a healthy environment for every community in Igbo-Eze North.</p>
        </div>
      </div>
    </section>
  );
};

export default WASHHero;